// Steuert, welche Konfigurationsoptionen im Feld-Editor je Feldtyp sinnvoll sind.
// Orientiert sich am Legacy-Builder (kategorie-einstellungen.js) und Runtime-Verhalten.

import { LAYOUT_FIELD_TYPES, normalizeFieldType } from "@/lib/fieldTypeCatalog";
import { ANSWER_RULE_SUPPORTED_FIELD_TYPES } from "./answerRules";

export interface FieldEditorCapabilities {
  /** Anzeigename im Formular. */
  label: boolean;
  /** Feldgruppe / Kategorie. */
  category: boolean;
  /** Semantische Rolle (nur Wartungsformular). */
  semanticRole: boolean;
  /** Pflichtfeld. */
  required: boolean;
  /** Technischer Feldschlüssel (Erweitert). */
  fieldKey: boolean;
  /** Sichtbarkeitsregeln. */
  visibilityRules: boolean;
  /** Antwortautomatik (answer_rules). */
  answerRules: boolean;
  /** Platzhaltertext. */
  placeholder: boolean;
  /** Hilfetext unter dem Feld. */
  helpText: boolean;
}

const DEFAULT: FieldEditorCapabilities = {
  label: true,
  category: true,
  semanticRole: true,
  required: true,
  fieldKey: true,
  visibilityRules: true,
  answerRules: false,
  placeholder: true,
  helpText: true,
};

/** Typ-spezifische Abweichungen vom Standard. */
const TYPE_OVERRIDES: Partial<Record<string, Partial<FieldEditorCapabilities>>> = {
  page_break: {
    label: false,
    category: false,
    semanticRole: false,
    required: false,
    fieldKey: false,
    visibilityRules: false,
    placeholder: false,
    helpText: false,
  },
  divider: {
    label: false,
    category: false,
    semanticRole: false,
    required: false,
    fieldKey: false,
    visibilityRules: false,
    placeholder: false,
    helpText: false,
  },
  static_text: {
    semanticRole: false,
    required: false,
    placeholder: false,
    helpText: false,
  },
  formula: {
    required: false,
    placeholder: false,
  },
  material_link: {
    semanticRole: false,
    placeholder: false,
  },
};

export function getFieldEditorCapabilities(rawType: string): FieldEditorCapabilities {
  const type = normalizeFieldType(rawType) || rawType;
  const override = TYPE_OVERRIDES[type] || {};
  return {
    ...DEFAULT,
    answerRules: ANSWER_RULE_SUPPORTED_FIELD_TYPES.has(type),
    ...override,
  };
}

/** Layout-Felder ohne Eingabewert (Seitenumbruch, Trennlinie, statischer Text). */
export function isStructuralLayoutField(rawType: string): boolean {
  const type = normalizeFieldType(rawType) || rawType;
  return LAYOUT_FIELD_TYPES.has(type);
}

/** Strukturelle Elemente ohne fachlichen Wert (Seitenumbruch, Trennlinie). */
export function isPureStructureField(rawType: string): boolean {
  const type = normalizeFieldType(rawType) || rawType;
  return type === "page_break" || type === "divider";
}
